import { render, staticRenderFns } from "./university.vue?vue&type=template&id=5d85c44a&scoped=true"
import script from "./university.vue?vue&type=script&lang=js"
export * from "./university.vue?vue&type=script&lang=js"
import style0 from "./university.vue?vue&type=style&index=0&id=5d85c44a&prod&scoped=true&lang=less"
import style1 from "./university.vue?vue&type=style&index=1&id=5d85c44a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85c44a",
  null
  
)

export default component.exports